export default __webpack_public_path__ + "static/media/rv_light.75f79959.png";